
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as aboutQd1Hg2FluzeNO0sCvq_xVnObVIZGJG8AZzX6s8ftwLsMeta } from "D:/DevOps-Agents/DO-Agent2/_work/1943/s/Ifen.IfenCatalog.Nuxt/app/pages/about.vue?macro=true";
import { default as index1AHRYfuwr_cTM4ewCNG4nUxIoaI8JQomPDZaiwaIUCoMeta } from "D:/DevOps-Agents/DO-Agent2/_work/1943/s/Ifen.IfenCatalog.Nuxt/app/pages/index.vue?macro=true";
import { default as searchKPN6aMe2hp1wcAR4yq7uOc55QwOfaHi8HJiD_VmZjM4Meta } from "D:/DevOps-Agents/DO-Agent2/_work/1943/s/Ifen.IfenCatalog.Nuxt/app/pages/search.vue?macro=true";
import { default as _91id_93_45ON66l5UmBW_nnPy5sQ3QU5EPzvYpErPt9fctsSF2r0Meta } from "D:/DevOps-Agents/DO-Agent2/_work/1943/s/Ifen.IfenCatalog.Nuxt/app/pages/course/[id].vue?macro=true";
import { default as _91id_93rz0DpSVt438n49OfdcjLFEEjGdwwQSZEz5_GWD1sRjkMeta } from "D:/DevOps-Agents/DO-Agent2/_work/1943/s/Ifen.IfenCatalog.Nuxt/app/pages/session/[id].vue?macro=true";
import { default as _91id_93IbK8ao_Gc_45iDn7GOIMff2vPDwaBYSgKR1ovGhtACAJQMeta } from "D:/DevOps-Agents/DO-Agent2/_work/1943/s/Ifen.IfenCatalog.Nuxt/app/pages/[domain]/[id].vue?macro=true";
export default [
  {
    name: "about",
    path: "/about",
    component: () => import("D:/DevOps-Agents/DO-Agent2/_work/1943/s/Ifen.IfenCatalog.Nuxt/app/pages/about.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("D:/DevOps-Agents/DO-Agent2/_work/1943/s/Ifen.IfenCatalog.Nuxt/app/pages/index.vue")
  },
  {
    name: "search",
    path: "/search",
    component: () => import("D:/DevOps-Agents/DO-Agent2/_work/1943/s/Ifen.IfenCatalog.Nuxt/app/pages/search.vue")
  },
  {
    name: "course-id",
    path: "/course/:id()",
    component: () => import("D:/DevOps-Agents/DO-Agent2/_work/1943/s/Ifen.IfenCatalog.Nuxt/app/pages/course/[id].vue")
  },
  {
    name: "session-id",
    path: "/session/:id()",
    component: () => import("D:/DevOps-Agents/DO-Agent2/_work/1943/s/Ifen.IfenCatalog.Nuxt/app/pages/session/[id].vue")
  },
  {
    name: "domain-id",
    path: "/:domain()/:id()",
    component: () => import("D:/DevOps-Agents/DO-Agent2/_work/1943/s/Ifen.IfenCatalog.Nuxt/app/pages/[domain]/[id].vue")
  }
]